<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-form @submit.prevent="$refs.form?.isValid && submit()" ref="form" class="d-flex flex-column h-100">
            <v-text-field
                :rules="$validation('required')"
                class="flex-grow-0"
                label="* عنوان"
                v-model="form.name"
            ></v-text-field>
            <ckeditor full class="flex-grow-1 overflow-hidden" v-model="form.body"></ckeditor>
            <div class="mt-4">
                <v-btn color="success" type="submit" :loading="loading">ثبت اطلاعات</v-btn>
                <v-btn color="error" class="ms-3" variant="text" @click="$router.push({path: '/settings/knowledgebaseTemplate'})" :disabled="loading">بازگشت</v-btn>
            </div>
        </v-form>
    </div>
</template>
<script>
export default {
    title: "ویرایش",
    validate(context) {
        return context.system.license.features.kb_core && context.rbac.can('manage knowledge base');
    },
    data() {
        return {
            loading: false,
            form: { name: null, body: '' },
        };
    },
    methods: {
        submit() {
            if(!this.form.body.replace(/<[^>]*>?/gm, ""))
                this.$toast.error('متن اجباری می‌باشد.')
            else {
                this.loading = true;
                this.$knowledgebaseTemplateUpdate(this.$route.params.id,this.form).then((res) => {
                    if (res && res.status == "UPDATED") {
                        this.$toast.success(res.message);
                        this.$system.setSystemDefaults(true);
                        this.$router.push({path: '/settings/knowledgebaseTemplate' });
                    }
                }).finally(()=>{this.loading = false;});
            }
        },
    },
    mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            await this.$knowledgebaseTemplateGet(this.$route.params.id).then((res) => {
                if (res && res.status == "OK") this.form = res.data;
            });
            this.$loading.finish();
        });
    },
};
</script>
